import { BaseSubjectStore } from "@/common";
import { RecipientType } from "@/models/enum";
import { Reminder, TemplateConfiguration, TemplateMetaTagConfiguration } from "@/models/interface";

interface NotificationStoreState {
    selectedRecipientType: RecipientType
    reminders: Reminder[]
    templates: TemplateConfiguration[]
    baseTemplate: TemplateConfiguration | null
    templateMetaTags: TemplateMetaTagConfiguration[]
    newlyCreatedTemplateId: string | null
    // Tenant-configured footer support address (FeedbackEmailAddress); null = not configured, previews show the default
    feedbackEmailAddress: string | null
}

export class NotificationStore extends BaseSubjectStore<NotificationStoreState> {
    getDefaultValue() {
        return {
            selectedRecipientType: RecipientType.WORKER,
            reminders: [],
            templates: [],
            baseTemplate: null,
            templateMetaTags: [],
            newlyCreatedTemplateId: null,
            feedbackEmailAddress: null
        }
    }

    public setFeedbackEmailAddress(feedbackEmailAddress: string | null) {
        this.dispatch({ feedbackEmailAddress })
    }

    public setSelectedRecipientType(recipient: RecipientType) {
        this.dispatch({ selectedRecipientType: recipient })
    }

    public setReminders(reminders: Reminder[]) {
        this.dispatch({ reminders })
    }

    public setTemplates(templates: TemplateConfiguration[]) {
        this.dispatch({ templates })
    }

    public setNewlyCreatedTemplateId(templateId: string | null) {
        this.dispatch({ newlyCreatedTemplateId: templateId })
    }

    public clearNewlyCreatedTemplateId() {
        this.dispatch({ newlyCreatedTemplateId: null })
    }
}

export const notificationStore = new NotificationStore()